import React, { useState, useEffect, useContext } from "react";
import { AuthContext } from "../../../contexts/AuthContext";
import { Button, Form, FormGroup, Label, Input, Row, Col } from "reactstrap";
import axios from "axios";


import Swal from "sweetalert2";

function AreasCreate() {
  const { user } = useContext(AuthContext);
  const URL_CONCEPTOS_GASTOS_EMBARQUES = import.meta.env.VITE_URL_CONCEPTOS_GASTOS_EMBARQUES;
  const URL_LOGS = import.meta.env.VITE_URL_LOGS;
  const [concepto, setConcepto] = useState("");
  const [estimado, setEstimado] = useState(0);
  const [fijo, setFijo] = useState(0);
  const [text, setText] = useState(false);
  const [validaBoton, setValidaBoton] = useState(true);



  const saveAreas = (event) => {
    event.preventDefault();
    setValidaBoton(false);
    axios
      .post(
        URL_CONCEPTOS_GASTOS_EMBARQUES,
        {
          concepto,
          estimado,
          fijo
        },
        {
          headers: {
            Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
          },
        }
      )
      .then(() => {
        axios.post(
          URL_LOGS,
          {
            tipo: "Crear Concepto Gasto",
            detalle: concepto,
            user: user.id,
          },
          {
            headers: {
              Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
            },
          }
        );
        Swal.fire("Good job!", "Creado con exito", "success");
        setTimeout(() => {
          window.location.reload();
        }, 1000);
      })
      .catch((error) => {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Something went wrong!",
          footer: `${error.response?.data?.message || error.response?.data?.error || 'Ocurrió un error inesperado'}`,
        });
        console.log(error);
      });
  };

  return (
    <>
      <div className="container">
        <h3 align="center">Crea un nuevo Concepto</h3>
        <Form onSubmit={saveAreas}>
          <FormGroup className="mb-2 mr-sm-2 mb-sm-0">
            <Label for="exampleEmail" className="mr-sm-2">
              Concepto
            </Label>
            <Input
              type="text"
              name="email"
              id="exampleEmail"
              placeholder="Concepto"
              value={concepto}
              required
              onChange={(e) => {
                setConcepto(e.target.value);
              }}
            />
               <Label for="exampleEmail" className="mr-sm-2">
              Estimado
            </Label>
            <Input
              type="text"
              name="email"
              id="exampleEmail"
              placeholder="Estimado"
              value={estimado}
              required
              onChange={(e) => {
                setEstimado(e.target.value);
              }}
            />
                 <Label>Fijo</Label>
                <Input
                    type="select"
                    placeholder="Fijo"
                    value={fijo}
                    required
                    onChange={(e) => {
                      setFijo(e.target.value);
                    }}
                  >
                    <option value="">Seleccione</option>
                    <option value="Si">Si</option>
                    <option value="No">No</option>
                  </Input>
          </FormGroup>
          <Row className="container">
            {validaBoton ? (
              <Button type="submit" className="btn btn-success">
                Guardar
              </Button>
            ) : (
              <Button type="submit" className="btn btn-success" disabled>
                Guardar
              </Button>
            )}
            <Button color="danger" href="/MenuCompras">
              Regresar
            </Button>
            </Row>
        </Form>
      </div>
    </>
  );
}

export default AreasCreate;
